import http from '../util/http.js'

export const GetSignature = () => http.get('/userSignature/getSignature')
export const SignatureSave = (userSignature) => http.post('/userSignature/save',userSignature)
export const Verify = (password) => http.post('/userSignature/verify',{password})
export const SendEmailCode = () => http.get('/userSignature/sendEmailCode')
export const CheckEmailCode = (emailCode) => http.post('/userSignature/checkEmailCode',{emailCode})
